import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

export default function LogoutApp() {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(true);
  const [companyLogo, setCompanyLogo] = useState("");
  const [companyName, setCompanyName] = useState("");

  const handleLogoutApp = async () => {
    try {
      setIsLoggingOut(true);

      const serverFolder = localStorage.getItem("server_folder");
      const serverUrl = localStorage.getItem("server_url");
      const company_id = localStorage.getItem("company_id");
      const company_header_logo = localStorage.getItem("company_header_logo");
      const company_name =
        localStorage.getItem("company_name") || "Your Account";

      setCompanyLogo(company_header_logo || "");
      setCompanyName(company_name);

      localStorage.clear();

      if (serverFolder) localStorage.setItem("server_folder", serverFolder);
      if (serverUrl) localStorage.setItem("server_url", serverUrl);
      if (company_id) localStorage.setItem("company_id", company_id);
      if (company_header_logo)
        localStorage.setItem("company_header_logo", company_header_logo);
      if (company_name) localStorage.setItem("company_name", company_name);

      await new Promise((resolve) => setTimeout(resolve, 1000));

      toast.success("Logged out successfully");
    } catch (error) {
      console.error("Logout error:", error);
      toast.error("An error occurred during logout");
    } finally {
      setIsLoggingOut(false);
    }
  };

  const handleLoginAgain = () => {
    navigate("/login");
  };

  useEffect(() => {
    handleLogoutApp();
  }, []);

  return (
    <div className="logout-container">
      <div className="logout-card">
        <div className="logout-header"></div>

        {companyLogo && (
          <div className="company-logo-container">
            <img src='https://mydigigarage.com/build_v1/img/2.png' alt={companyName} className="company-logo" />
          </div>
        )}

        <div className="logout-content">
          {isLoggingOut ? (
            <div className="logging-out">
              <div className="spinner"></div>
              <h3 className="logging-out-text">Logging you out...</h3>
            </div>
          ) : (
            <>
              <div className="logout-icon-container">
                <svg
                  className="logout-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
              </div>

              <h1 className="logout-title">You're Logged Out</h1>

              <p className="logout-message">
                You have been successfully logged out of{" "}<br/>
                <strong>{companyName}</strong>.
                <br />
                Your session has been securely ended.
              </p>

              <div className="login-again-container">
                <button
                  className="login-again-button"
                  onClick={handleLoginAgain}
                >
                  <svg
                    className="login-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                    />
                  </svg>
                  Click here to login again
                </button>
              </div>

              {/* <p className="logout-help-text">
                Need help? Contact your system administrator
              </p> */}
            </>
          )}
        </div>

        <div className="logout-decoration bottom"></div>
      </div>
      <style jsx>{`
        .logout-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          padding: 20px;
        }

        .logout-card {
          background: white;
          border-radius: 16px;
          padding: 40px;
          width: 100%;
          max-width: 500px;
          text-align: center;
          position: relative;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          animation: fadeIn 0.8s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .logout-header {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #1976d2 0%, #2196f3 100%);
        }

        .company-logo-container {
          margin-bottom: 24px;
        }

        .company-logo {
          height: 80px;
          object-fit: contain;
          border: 3px solid #e3f2fd;
          margin: 0 auto;
        }

        .logout-content {
          margin: 32px 0;
        }

        .logging-out {
          padding: 40px 0;
        }

        .spinner {
          width: 60px;
          height: 60px;
          border: 4px solid #e3f2fd;
          border-top: 4px solid #1976d2;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 24px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .logging-out-text {
          color: #666;
          font-weight: 500;
          margin: 0;
        }

        .logout-icon-container {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: #e8f4ff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 24px;
          border: 2px solid #bbdefb;
        }

        .logout-icon {
          width: 40px;
          height: 40px;
          color: #1976d2;
        }

        .logout-title {
          color: #1a237e;
          font-size: 28px;
          font-weight: 700;
          margin: 0 0 16px 0;
        }

        .logout-message {
          color: #666;
          font-size: 16px;
          line-height: 1.6;
          margin: 0 0 32px 0;
        }

        .login-again-container {
          margin: 40px 0 32px;
        }

        .login-again-button {
          background: linear-gradient(90deg, #1976d2 0%, #2196f3 100%);
          color: white;
          border: none;
          padding: 15px 30px;
          font-size: 16px;
          font-weight: 600;
          border-radius: 12px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
        }

        .login-again-button:hover {
          box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4);
          transform: translateY(-1px);
        }

        .login-icon {
          width: 20px;
          height: 20px;
        }

        .logout-help-text {
          color: #888;
          font-size: 14px;
          margin: 0;
          opacity: 0.7;
        }

        .logout-decoration {
          position: absolute;
          border-radius: 50%;
          z-index: 0;
        }

        .logout-decoration.top {
          top: -50px;
          right: -50px;
          width: 150px;
          height: 150px;
          background: radial-gradient(circle, #e3f2fd 0%, transparent 70%);
        }

        .logout-decoration.bottom {
          bottom: -50px;
          left: -50px;
          width: 150px;
          height: 150px;
          background: radial-gradient(circle, #f3e5f5 0%, transparent 70%);
        }

        @media (max-width: 600px) {
          .logout-card {
            padding: 24px;
          }

          .logout-title {
            font-size: 24px;
          }

          .logout-message {
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
}
